/** 鉴权相关：token 存取 + 登录/注册/me 接口 */
import { apiGet, apiJson } from './client';

const TOKEN_KEY = 'znjj_token';

export const tokenStore = {
  get: (): string | null => localStorage.getItem(TOKEN_KEY),
  set: (token: string): void => localStorage.setItem(TOKEN_KEY, token),
  clear: (): void => localStorage.removeItem(TOKEN_KEY),
};

export interface PublicUser {
  id: string;
  email: string;
  nickname: string;
  avatarUrl: string | null;
  createdAt: string;
}

export function login(email: string, password: string): Promise<{ token: string; user: PublicUser }> {
  return apiJson<{ token: string; user: PublicUser }>('POST', '/api/auth/login', { email, password });
}

export function register(
  email: string,
  password: string,
  nickname?: string,
): Promise<{ token: string; user: PublicUser }> {
  return apiJson<{ token: string; user: PublicUser }>('POST', '/api/auth/register', {
    email,
    password,
    ...(nickname ? { nickname } : {}),
  });
}

export function fetchMe(): Promise<{ user: PublicUser }> {
  return apiGet<{ user: PublicUser }>('/api/auth/me');
}

/** 头像文本：昵称首字（中文取首字，英文取首字母大写） */
export function avatarText(nickname: string): string {
  const n = nickname.trim();
  if (!n) return '我';
  return /[\u4e00-\u9fa5]/.test(n[0]) ? n[0] : n[0].toUpperCase();
}
